<template>
  <div id="contenedor-tabla-listado-respuestas">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              class="font-weight-medium grey lighten-3"
            >
              {{ header.text }}
            </td>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in items">
            <template>
              <tr :key="item.id" class="font-weight-medium grey lighten-3">
                <td>
                  <v-btn @click="toggleDetails(item.id)" icon text>
                    <v-icon>
                      {{ isActive(item.id) ? "mdi-minus" : "mdi-plus" }}
                    </v-icon>
                  </v-btn>
                </td>
                <td>
                  {{ item.numeroOficio }}
                </td>
                <td class="font-weight-light">
                  {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
                </td>
                <td class="font-weight-light">
                  {{ new Date(`${item.fechaEntrega} 00:00:0`).toLocaleDateString() }}
                </td>
                <td class="font-weight-light">
                  <span class="text-caption font-weight-light">
                    <cortar-texto
                      :texto="item.comentarios ? item.comentarios : ''"
                      :cantidad-caracteres="45"
                    >
                    </cortar-texto
                  ></span>
                </td>
                <td class="font-weight-light">
                  <FechaHumano :fecha="item.createdAt"></FechaHumano>
                </td>
                <td>
                  <v-tooltip v-if="item.dataFile && item.dataFile !== '' ? true : false" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="base6" icon v-bind="attrs" v-on="on" @click="verPdf(item)">
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver PDF</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip top
                  v-if="mixValidaScopesActions(1)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                        <v-icon @click="botonAgregarDetalle(item)">
                          mdi-file-plus-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Seleccionar Detalles
                    </span>
                  </v-tooltip>
                  <v-tooltip top
                  v-if="mixValidaScopesActions(2)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                        <v-icon @click="botonEditarRespuesta(item)">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Editar Respuesta
                    </span>
                  </v-tooltip>
                  <v-tooltip top
                  v-if="mixValidaScopesActions(3)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                        <v-icon @click="botonEliminarRespuesta(item)">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Eliminar Respuesta
                    </span>
                  </v-tooltip>
                </td>
              </tr>
              <tr
                v-show="isActive(item.id)"
                v-for="(detalle) in item.detalles"
                :key="`detalles-${detalle.id}`"
                class="text--secondary"
              >
                <td>
                  <!-- RESPUESTA COMPLETA -->
                  <template v-if="!detalle.esRespuestaParcial">
                    <v-avatar size="25" color="base4">
                      <v-icon dark="dark" size="Large" color="success">
                        mdi-check-circle
                      </v-icon>
                    </v-avatar>
                  </template>
                </td>
                <!--
                <td class="text-caption">
                  <span style="padding-left: 20px; display: block;">
                    {{ index + 1 }}
                  </span>
                </td>
                -->
                <td class="text-caption" color="primary" colspan="2">
                  <span
                  class="font-weight-bold azul2--text"
                  style="padding-left: 10px; display: block;"
                  v-if="detalle.observacionDetalle.auditoriaObservacion.numero">
                  {{detalle.observacionDetalle.auditoriaObservacion.numero}}</span>
                  <span
                  class="text-caption font-weight-light"
                  style="padding-left: 10px; display: block;"
                  v-if="detalle.observacionDetalle.auditoriaObservacion.descripcion">
                  <cortar-texto
                    :texto="detalle.observacionDetalle.auditoriaObservacion ?
                    detalle.observacionDetalle.auditoriaObservacion.descripcion : ''"
                    >
                  </cortar-texto>
                  </span>
                </td>
                <td class="text-caption" color="primary" colspan="2">
                  <span
                  class="font-weight-bold naranja--text"
                  style="display: block;"
                  v-if="detalle.observacionDetalle && detalle.observacionDetalle.contrato">
                  {{detalle.observacionDetalle.contrato.numero}}</span>
                  <span
                  class="text-caption font-weight-light"
                  style="display: block;"
                  v-if="detalle.observacionDetalle">
                  <cortar-texto
                    :texto="detalle.observacionDetalle ?
                    detalle.observacionDetalle.texto : ''"
                    :cantidad-caracteres="45">
                  </cortar-texto>
                  </span>
                </td>
                <td colspan="1" class="caption">
                  <span class="text-caption font-weight-light">
                    <cortar-texto
                      :texto="detalle.comentarios ? detalle.comentarios : ''"
                      :cantidad-caracteres="45"
                    >
                    </cortar-texto
                  ></span>
                </td>
                <td>
                  <template>
                  <v-chip small color="base6"  class="caption--text bkground--text">
                    {{detalle.documentos.length}}
                  </v-chip>
                </template>
                </td>
                <td>
                  <v-tooltip top
                  v-if="mixValidaScopesActions(0)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                        <v-icon @click="documentosDetalle(detalle)">
                          mdi-folder
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Archivos del Detalle de la Respuesta
                    </span>
                  </v-tooltip>
                  <v-tooltip top
                  v-if="mixValidaScopesActions(2)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                        <v-icon @click="botonEditarDetalle(detalle)">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Editar Detalle
                    </span>
                  </v-tooltip>
                  <v-tooltip top
                  v-if="mixValidaScopesActions(3)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                        <v-icon @click="botonEliminarDetalle(detalle,item)">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Eliminar Detalle
                    </span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <!-- Ventana Ver Pdf Respuesta -->
    <v-dialog
      v-if="!$apollo.loading && estaRespuesta && mostrarVerPdfRespuesta"
      v-model="mostrarVerPdfRespuesta"
      persistent
      scrollable
      width="750px"
    >
      <v-card>
        <v-card-title>
          {{ estaRespuesta.numeroOficio }}
          / {{ estaRespuesta.fecha }}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarPdf()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf :ruta-archivo="estaRespuesta.dataFile"> </VistaPreviaPdf>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Ventana Editar Respuesta -->
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarRespuesta"
      v-model="mostrarEditarRespuesta"
      width="600px"
      persistent
    >
      <EditarRespuesta
        v-on:cerrar="mostrarEditarRespuesta = !mostrarEditarRespuesta"
        :respuestaEditar="estaRespuesta"
      >
      </EditarRespuesta>
    </v-dialog>
    <!-- Ventana Eliminar Respuesta -->
    <v-dialog
        v-if="!$apollo.loading && mostrarEliminarRespuesta"
        v-model="mostrarEliminarRespuesta"
        width="500px"
        persistent
        >
        <EliminarRespuesta
        v-on:cerrar="mostrarEliminarRespuesta=!mostrarEliminarRespuesta"
        :respuesta="estaRespuesta">
        </EliminarRespuesta>
    </v-dialog>
    <!-- Ventana Agregar Detalle -->
    <v-dialog
        v-if="!$apollo.loading && mostrarAgregarDetalle"
        v-model="mostrarAgregarDetalle"
        width="600px"
        scrollable
        persistent
        >
        <NuevoDetalle
          v-on:cerrar="mostrarAgregarDetalle = !mostrarAgregarDetalle"
          :respuesta="estaRespuesta"
          :informe="informe"
          >
        </NuevoDetalle>
    </v-dialog>
    <!-- Ventana Eliminar Detalle -->
    <v-dialog
      v-if="!$apollo.loading && mostrarEliminarDetalle"
      v-model="mostrarEliminarDetalle"
      width="500px"
      persistent
    >
      <EliminarDetalle
        v-on:cerrar="mostrarEliminarDetalle = !mostrarEliminarDetalle"
        :respuestaDetalle="esteDetalle"
        :respuesta="estaRespuesta"
        :informe="informe"
      >
      </EliminarDetalle>
    </v-dialog>
    <!-- Ventana Editar Detalle -->
    <v-dialog
        v-if="!$apollo.loading && mostrarEditarDetalle"
        v-model="mostrarEditarDetalle"
        width="600px"
        persistent
        >
        <EditarDetalle
        v-on:cerrar="mostrarEditarDetalle=!mostrarEditarDetalle"
        :respuestaDetalleEditar="esteDetalle"
        :informe="informe">
        </EditarDetalle>
    </v-dialog>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import EditarRespuesta from '@/components/administracion/auditorias/respuestas/Editar.vue';
import EliminarRespuesta from '@/components/administracion/auditorias/respuestas/Eliminar.vue';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import NuevoDetalle from '@/components/administracion/auditorias/respuestas/detalles/Nuevo.vue';
import EliminarDetalle from '@/components/administracion/auditorias/respuestas/detalles/Eliminar.vue';
import EditarDetalle from '@/components/administracion/auditorias/respuestas/detalles/Editar.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContenedorTablaListadoRespuestas',
  props: {
    items: {
      type: Array,
      required: false,
    },
    informe: {
      type: Object,
      required: true,
    },
  },
  components: {
    FechaHumano,
    CortarTexto,
    EditarRespuesta,
    EliminarRespuesta,
    VistaPreviaPdf,
    NuevoDetalle,
    EliminarDetalle,
    EditarDetalle,
  },
  data() {
    return {
      activeRow: null,
      mostrarEditarRespuesta: false,
      mostrarEliminarRespuesta: false,
      mostrarVerPdfRespuesta: false,
      mostrarAgregarDetalle: false,
      mostrarEliminarDetalle: false,
      mostrarEditarDetalle: false,
      esteDetalle: {},
      estaRespuesta: {},
      headers: [
        {
          text: '',
          value: 'toggle',
          sortable: false,
        },
        {
          text: 'Número',
          value: 'numero',
          align: 'left',
          sortable: true,
        },
        { text: 'Fecha', value: 'fecha' },
        { text: 'F.Entrega', value: 'fechaEntrega' },
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'Registro', value: 'createdAt' },
        {
          text: 'Anexo',
          value: 'verPdf',
          align: 'end',
          sortable: false,
        },
        {
          text: '',
          value: 'acciones',
          align: 'end',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    toggleDetails(row) {
      this.activeRow = this.activeRow === row ? null : row;
    },
    isActive(row) {
      return this.activeRow === row;
    },
    botonEditarRespuesta(respuesta) {
      this.estaRespuesta = respuesta;
      this.mostrarEditarRespuesta = true;
    },
    botonEliminarRespuesta(respuesta) {
      this.estaRespuesta = respuesta;
      this.mostrarEliminarRespuesta = true;
    },
    verPdf(respuesta) {
      this.mostrarVerPdfRespuesta = true;
      this.estaRespuesta = respuesta;
    },
    cerrarPdf() {
      this.mostrarVerPdfRespuesta = !this.mostrarVerPdfRespuesta;
      this.estaRespuesta = null;
    },
    botonAgregarDetalle(respuesta) {
      this.estaRespuesta = respuesta;
      this.mostrarAgregarDetalle = true;
    },
    botonEliminarDetalle(detalle, respuesta) {
      this.esteDetalle = detalle;
      this.estaRespuesta = respuesta;
      this.mostrarEliminarDetalle = true;
    },
    documentosDetalle(detalle) {
      eventBus.$emit('documentos-detalle', detalle);
    },
    botonEditarDetalle(detalle) {
      this.esteDetalle = detalle;
      this.mostrarEditarDetalle = true;
    },
  },
};
</script>

<style scoped>
.obervacion-indent td {
  padding-left: 10px;
}
</style>
